import { useState, useRef, TouchEvent } from 'react';

const products = [
  {
    id: 'cassonetti',
    tag: 'Bestseller',
    title: 'Cassonetti in PVC',
    subtitle: 'Per tapparelle, avvolgibili e veneziane',
    desc: 'Produzione su misura per ogni foro finestra. Isolamento termico integrato con certificazione Usb=1 W/m²K, pannello ispezione a scatto brevettato.',
    points: [
      'Dimensioni personalizzate in 48 ore',
      'Certificazione trasmittanza Usb=1 W/m²K',
      'Pannello ispezione a scatto brevettato',
      '100% Made in Italy',
    ],
    img: 'https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/4b3c35fe759b3117bd015573bc63da95.jpeg',
  },
  {
    id: 'controtelai',
    tag: 'Pronta consegna',
    title: 'Controtelai per Finestre',
    subtitle: 'Falso telaio termico per finestre e portefinestre',
    desc: 'Eliminazione dei ponti termici, isolamento acustico e connessione ottimale tra serramento e muratura. Compatibili con PVC, alluminio e legno.',
    points: [
      'Elimina ponti termici e acustici',
      'Compatibile con PVC, alluminio e legno',
      'Certificazione energetica inclusa',
      'Supporto tecnico diretto',
    ],
    img: 'https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/dfc46446e67a5d9e10b6b84f2f5151a8.jpeg',
  },
  {
    id: 'termiko',
    tag: 'Esclusiva brevettata',
    title: 'Termiko®',
    subtitle: 'Controtelaio in kit universale — brevettato',
    desc: 'Il controtelaio brevettato Termiko® si adatta a tutti i fori finestra senza sopralluogo. Il kit viene spedito e installato in poche ore.',
    points: [
      'Si adatta a tutti i fori finestra',
      'Installazione senza sopralluogo preventivo',
      'Kit completo pronto da montare',
      'Riduzione drastica dei tempi di posa',
    ],
    img: 'https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/a44dad27a72d70a3ae1dc3cd0eb93a5a.png',
  },
  {
    id: 'monoblocco',
    tag: 'All-in-one',
    title: 'Monoblocco per Tapparelle',
    subtitle: 'Cassonetto + controtelaio in un unico elemento',
    desc: 'Il monoblocco integra cassonetto e controtelaio in un unico prefabbricato. Installazione veloce, massimo isolamento termico e acustico.',
    points: [
      'Cassonetto e controtelaio integrati',
      'Installazione rapida in cantiere',
      'Zero ponti termici garantiti',
      'Ottimale per nuove costruzioni',
    ],
    img: 'https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/f45bcdcb20ca7c3ebe187a48738ed4cd.jpeg',
  },
];

const diffs = [
  { bigText: '48h', label: 'Consegna su misura', icon: 'ri-timer-flash-line' },
  { bigText: '100%', label: 'Made in Italy', icon: 'ri-flag-line' },
  { bigText: 'Usb=1', label: 'W/m²K certificato', icon: 'ri-award-line' },
  { bigText: '1 tecnico', label: 'Referente diretto', icon: 'ri-user-voice-line' },
];

export default function ProductsSection() {
  const [active, setActive] = useState(0);
  const [expandedCard, setExpandedCard] = useState<string | null>(null);
  const touchStartX = useRef<number | null>(null);
  const p = products[active];

  const handleTouchStart = (e: TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e: TouchEvent) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) setActive((prev) => Math.min(prev + 1, products.length - 1));
      else setActive((prev) => Math.max(prev - 1, 0));
    }
    touchStartX.current = null;
  };

  const scrollToForm = () => {
    document.getElementById('form')?.scrollIntoView({ behavior: 'smooth' });
  };

  const toggleCard = (id: string) => {
    setExpandedCard((prev) => (prev === id ? null : id));
  };

  return (
    <section id="prodotti" className="bg-[#111111]">

      {/* ===== DIFF STRIP (mobile + desktop) ===== */}
      <div className="border-b border-white/8">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-5 md:py-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-0 md:divide-x md:divide-white/10">
            {diffs.map((d) => (
              <div key={d.label} className="flex items-center gap-3 md:px-6 first:md:pl-0 last:md:pr-0">
                <div className="w-8 h-8 flex items-center justify-center bg-[#7FCDCD]/10 rounded-lg flex-shrink-0">
                  <i className={`${d.icon} text-[#7FCDCD] text-sm`} />
                </div>
                <div>
                  <div
                    className="text-white font-black text-sm leading-none mb-0.5"
                    style={{ fontFamily: "'Raleway', sans-serif" }}
                  >
                    {d.bigText}
                  </div>
                  <div className="text-white/35 text-[10px] font-medium uppercase tracking-wider whitespace-nowrap">
                    {d.label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ========== MOBILE: Card per prodotto ========== */}
      <div className="md:hidden px-4 py-12">

        {/* Header mobile */}
        <div className="mb-8">
          <span className="inline-block text-[#7FCDCD] text-xs font-semibold uppercase tracking-widest mb-3" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            — I nostri prodotti
          </span>
          <h2
            className="text-3xl font-black text-white leading-tight tracking-tighter"
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            Produzione PVC<br />
            <span className="text-white/30">su misura in 48 ore</span>
          </h2>
        </div>

        {/* Cards */}
        <div className="flex flex-col gap-4">
          {products.map((prod) => {
            const isOpen = expandedCard === prod.id;
            return (
              <div
                key={prod.id}
                className="rounded-2xl overflow-hidden border border-white/10 bg-[#1a1a1a]"
              >
                {/* Immagine — sempre visibile */}
                <button
                  onClick={() => toggleCard(prod.id)}
                  className="relative w-full cursor-pointer block"
                  style={{ height: '220px' }}
                  aria-expanded={isOpen}
                >
                  <img
                    src={prod.img}
                    alt={`${prod.title} – Punto Cassonetti, produzione PVC su misura in 48 ore`}
                    className="w-full h-full object-cover object-center"
                    style={{ height: '220px' }}
                  />
                  {/* Gradient leggero solo in basso */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-transparent to-transparent" />

                  {/* Badge tag */}
                  <div className="absolute top-3 left-3">
                    <span className="bg-[#7FCDCD] text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider">
                      {prod.tag}
                    </span>
                  </div>

                  {/* Titolo + icona espansione sovrapposti in basso */}
                  <div className="absolute bottom-0 left-0 right-0 px-4 pb-3 flex items-end justify-between">
                    <div>
                      <p className="text-[#7FCDCD] text-[10px] font-semibold uppercase tracking-widest leading-none mb-1" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                        {prod.subtitle}
                      </p>
                      <h3
                        className="text-white text-xl font-black leading-tight tracking-tight"
                        style={{ fontFamily: "'Raleway', sans-serif" }}
                      >
                        {prod.title}
                      </h3>
                    </div>
                    <div
                      className={`w-8 h-8 flex items-center justify-center rounded-full border border-white/20 bg-white/10 flex-shrink-0 ml-3 transition-transform duration-300 ${isOpen ? 'rotate-45' : 'rotate-0'}`}
                    >
                      <i className="ri-add-line text-white text-base" />
                    </div>
                  </div>
                </button>

                {/* Descrizione espandibile */}
                <div
                  className={`overflow-hidden transition-all duration-400 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
                >
                  <div className="px-4 pt-4 pb-5">
                    <p
                      className="text-white/55 text-sm leading-relaxed mb-4"
                      style={{ fontFamily: "'DM Sans', sans-serif" }}
                    >
                      {prod.desc}
                    </p>

                    {/* Punti chiave */}
                    <ul className="space-y-2 mb-5">
                      {prod.points.map((pt) => (
                        <li key={pt} className="flex items-center gap-2 text-white/75 text-sm" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                          <i className="ri-checkbox-circle-fill text-[#7FCDCD] flex-shrink-0 text-sm" />
                          {pt}
                        </li>
                      ))}
                    </ul>

                    {/* CTA */}
                    <div className="flex gap-2">
                      <button
                        onClick={scrollToForm}
                        className="flex-1 flex items-center justify-center gap-2 bg-[#7FCDCD] text-white font-bold py-3 rounded-xl text-sm whitespace-nowrap cursor-pointer"
                        style={{ fontFamily: "'DM Sans', sans-serif" }}
                      >
                        <i className="ri-file-list-3-line" />
                        Preventivo
                      </button>
                      <a
                        href="tel:+390519981801"
                        className="flex items-center justify-center gap-2 border border-white/20 text-white/70 font-semibold py-3 px-4 rounded-xl text-sm whitespace-nowrap cursor-pointer"
                        style={{ fontFamily: "'DM Sans', sans-serif" }}
                      >
                        <i className="ri-phone-line" />
                        Chiama
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* ========== DESKTOP: Tab showcase (unchanged) ========== */}
      <div className="hidden md:block py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-5 md:px-10">

          <div className="mb-10">
            <span className="inline-block text-[#7FCDCD] text-xs font-semibold uppercase tracking-widest mb-3" style={{ fontFamily: "'DM Sans', sans-serif" }}>
              — I nostri prodotti
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight tracking-tight" style={{ fontFamily: "'Raleway', sans-serif" }}>
              Produzione PVC su misura<br />
              <span className="text-white/30">in 48 ore lavorative</span>
            </h2>
          </div>

          <div className="flex flex-wrap gap-2 mb-8">
            {products.map((prod, i) => (
              <button
                key={prod.id}
                onClick={() => setActive(i)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer border ${
                  active === i
                    ? 'bg-[#7FCDCD] text-white border-[#7FCDCD]'
                    : 'bg-white/5 text-white/50 border-white/10 hover:bg-white/10 hover:text-white/80'
                }`}
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                <span className={`text-xs font-black ${active === i ? 'text-white/70' : 'text-white/25'}`}>0{i + 1}</span>
                {prod.title}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 rounded-2xl overflow-hidden border border-white/8 min-h-[460px]">
            <div className="relative h-72 lg:h-full min-h-[320px] overflow-hidden">
              <img
                key={p.id}
                src={p.img}
                alt={`${p.title} – Punto Cassonetti, produzione PVC su misura certificata Usb=1 W/m²K`}
                title={`${p.title} – Cassonetti e controtelai PVC Made in Italy, preventivo gratuito 48 ore`}
                className="w-full h-full object-cover object-center transition-opacity duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-[#1a1a1a] hidden lg:block" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <div className="absolute top-5 left-5">
                <span className="bg-[#7FCDCD] text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider">{p.tag}</span>
              </div>
            </div>

            <div className="bg-[#1a1a1a] p-8 md:p-12 flex flex-col justify-center">
              <p className="text-[#7FCDCD] font-semibold text-xs uppercase tracking-widest mb-2" style={{ fontFamily: "'DM Sans', sans-serif" }}>{p.subtitle}</p>
              <h3 className="text-3xl md:text-4xl font-extrabold text-white mb-4 leading-tight tracking-tight" style={{ fontFamily: "'Raleway', sans-serif" }}>{p.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-7" style={{ fontFamily: "'DM Sans', sans-serif" }}>{p.desc}</p>
              <ul className="space-y-2.5 mb-8">
                {p.points.map((pt) => (
                  <li key={pt} className="flex items-center gap-3 text-white/75 text-sm" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                    <i className="ri-checkbox-circle-fill text-[#7FCDCD] flex-shrink-0" />
                    {pt}
                  </li>
                ))}
              </ul>
              <div className="flex flex-wrap gap-3">
                <a href="#form" className="inline-flex items-center gap-2 bg-[#7FCDCD] hover:bg-[#6bbaba] text-white font-bold py-3.5 px-7 rounded-md transition-all text-sm whitespace-nowrap cursor-pointer" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                  <i className="ri-file-list-3-line" />
                  Preventivo per {p.title}
                </a>
                <a href="tel:+390519981801" className="inline-flex items-center gap-2 border border-white/15 hover:border-white/40 text-white/50 hover:text-white font-semibold py-3.5 px-5 rounded-md transition-all text-sm whitespace-nowrap cursor-pointer" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                  <i className="ri-phone-line" />
                  Chiama
                </a>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 mt-6">
            {products.map((_, i) => (
              <button key={i} onClick={() => setActive(i)} className={`transition-all duration-200 rounded-full cursor-pointer ${active === i ? 'w-6 h-2 bg-[#7FCDCD]' : 'w-2 h-2 bg-white/20 hover:bg-white/40'}`} />
            ))}
          </div>
        </div>
      </div>

      {/* ===== GUARANTEE STRIP (desktop only) ===== */}
      <div className="hidden md:block max-w-7xl mx-auto px-5 md:px-10 pb-14">
        <div className="relative rounded-2xl p-6 md:p-8 overflow-hidden">
          <img
            src="https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/dfc46446e67a5d9e10b6b84f2f5151a8.jpeg"
            alt="Certezza operativa – Punto Cassonetti, cassonetti PVC e controtelai termici Made in Italy"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-black/70 rounded-2xl" />
          <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="flex items-start gap-4 flex-1 min-w-0">
              <div className="w-10 h-10 flex items-center justify-center bg-[#7FCDCD]/15 rounded-xl flex-shrink-0">
                <i className="ri-shield-check-line text-[#7FCDCD] text-lg" />
              </div>
              <div className="min-w-0">
                <div
                  className="text-white font-bold text-base md:text-lg leading-snug mb-1"
                  style={{ fontFamily: "'Raleway', sans-serif" }}
                >
                  Non vendiamo pezzi. Vendiamo certezza operativa.
                </div>
                <div className="text-white/40 text-xs md:text-sm" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                  Misure verificate · Produzione tracciata · Consegna puntuale
                </div>
              </div>
            </div>
            <a
              href="#form"
              onClick={(e) => { e.preventDefault(); document.getElementById('form')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="w-full md:w-auto flex items-center justify-center gap-2 bg-[#7FCDCD] hover:bg-[#6bbaba] text-white font-black px-6 py-3.5 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors flex-shrink-0"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              <i className="ri-file-list-3-line" />
              Preventivo gratuito
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
